document.querySelectorAll('[data-product-complement-form]').forEach((form) => {
  if (form.dataset.initialized === 'true') return;
  form.dataset.initialized = 'true';

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-product-complement-add]');
    const label = button?.querySelector('[data-product-complement-label]');
    if (!button || !label || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.dataset.addState = 'loading';
    label.textContent = button.dataset.loadingLabel;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);

      button.dataset.addState = 'success';
      label.textContent = button.dataset.successLabel;
      document.dispatchEvent(new CustomEvent('avey:cart:added', {
        detail: { items: [result], source: 'product-complement', opener: button },
      }));
      window.setTimeout(() => {
        button.dataset.addState = 'available';
        label.textContent = button.dataset.defaultLabel;
      }, 900);
    } catch (error) {
      button.dataset.addState = 'error';
      form.submit();
    } finally {
      button.disabled = false;
      button.setAttribute('aria-busy', 'false');
    }
  });
});
